export const getCurrentLanguage = () => {
    return document.querySelector('html').attributes.lang.value
}

export const buildQueryFromState = (state) => {
    return Object.entries(state)
        .filter(([, value]) => Array.isArray(value) ? value.length > 0 : value)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
}

export const extractItemsFromStore = (state, defaultPlaceholder) => {
    if (state === '') {
        return defaultPlaceholder;
    }

    const items = state.split(';')
    const singleItems = items.map(i => {
        const value = i.split('.');

        return value.length === 2 ? value[1] : value[0];
    });

    return singleItems.join(',');
}

export const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1)
